(() => {
    const BONUS_PRODUCT_ID = 44862682923272; 
    const TARGET_PRODUCT_IDS = [9603273949448,  
        9603301835016,
        9603284238600,
        9603281682696,
        9603280961800,
        9603280306440,
        9603279814920,
        9603279356168,
        9603275981064,
        9603334570248,
        9603267592456,
        9603265462536,
        9603265233160,
        9603264676104,
        9603263922440,
        9603261956360,
        9602592112904,
        7644683174128,
        7644682322160,
        7439044706544,
        7439044083952,
        7439043920112,
        7439043592432,
        7437866434800,
        10601007382792];

    function log(msg, type = "info") {
        const prefix = "%c[Bonus Sync]";
        const style = {
            info: "color: #2196f3; font-weight: bold;",
            success: "color: #4caf50; font-weight: bold;",
            warn: "color: #ff9800; font-weight: bold;",
            error: "color: #f44336; font-weight: bold;"
        }[type] || "";

        console.log(prefix, style, msg);
    }

    function syncBonusProduct() {
        log("Starte Bonus-Sync…");

        fetch("/cart.js")
            .then(res => {
                log("Warenkorb erfolgreich geladen.", "success");

                return res.json();
            })
            .then(async cart => {
                const OIL_PRODUCT_IDS = [50931186008328, 50931189219592];

                const nonOilItems = cart.items.filter(i => {
                    console.log('item: ' + JSON.stringify(i));
                    console.log(i);
                    return i.quantity > 0 && !OIL_PRODUCT_IDS.includes(i.id);
                    }
                );
                const oilItems = cart.items.filter(i => {
                        return i.quantity > 0 && OIL_PRODUCT_IDS.includes(i.id);
                    }
                );
                const onlyOil =  nonOilItems.length === 0;
                
                if (onlyOil) {
                    if (oilItems.length > 0) {
                        fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                id: oilItems[0].key,
                                quantity: 0
                            })
                        }).then(() => {
                            log(`✅ Öl item gelöscht.`, "success");
                            location.reload();
                        });
                    }
                     
                }
                
                let targetQty = 0;
                let bonusQty = 0;
                let partnerVisit = 0;

                await Promise.all(cart.items.map( async (item) => {
                    const res = await fetch(`/products/${item.handle}.js`);
                    const product = await res.json();
                    if (product.tags.includes('deposit') /*TARGET_PRODUCT_IDS.includes(item.product_id)*/) {
                        log(`Zielprodukt gefunden (ID: ${item.product_id}, Menge: ${item.quantity})`);
                        targetQty += item.quantity;
                    }
                    if (item.id === BONUS_PRODUCT_ID) {
                        log(`Bonusprodukt bereits im Warenkorb (Menge: ${item.quantity})`);
                        bonusQty = item.quantity;
                    }

                    if (item.id === 50930575900936 || item.id === 50930739970312 || item.id === 50930952175880 || item.id === 50931022725384 ||
                        item.id === 51466332537096 || item.id === 51466403348744 || item.id === 51466394501384 || item.id === 51445587738888) {
                        log(`Partnerwerkstatt im Warenkorb (Menge: ${item.quantity})`);
                        partnerVisit += item.quantity;
                    }
                }));

                const diff = targetQty - bonusQty - partnerVisit;
                log(`Zielprodukt-Gesamtmenge: ${targetQty}, Bonusprodukt-Menge: ${bonusQty}, Differenz: ${diff}, partnerVisit: ${partnerVisit}`);

                if (diff > 0) {
                    log(`Füge ${diff} Bonusartikel hinzu…`, "info");
                    return fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: BONUS_PRODUCT_ID, quantity: diff })
                    }).then(() => {
                        log(`✅ ${diff} Bonusartikel erfolgreich hinzugefügt.`, "success");
                        location.reload();
                    });
                } else if (diff < 0) {
                    const bonusItem = cart.items.find(i => i.id === BONUS_PRODUCT_ID);
                    if (bonusItem) {
                        log(`Reduziere Bonusartikel auf ${targetQty - diff}…`, "warn");
                        return fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                id: bonusItem.key,
                                quantity: (targetQty - partnerVisit)
                            })
                        }).then(() => {
                            log(`✅ Bonusartikel erfolgreich reduziert.`, "success");
                            location.reload();
                        });
                    } else {
                        log("⚠️ Bonusprodukt zum Reduzieren nicht gefunden.", "warn");
                    }
                } else {
                    log("Keine Änderung nötig – Bonusmenge stimmt bereits.", "info");
                }
            })
            .catch(err => {
                log(`❌ Fehler beim Bonus-Sync: ${err.message}`, "error");
            });
    }

    // Listener auf "In den Warenkorb" Formulare
    document.addEventListener("submit", function (e) {
        const form = e.target;
        if (form && form.action.includes("/cart/add")) {
            log("Formular für 'In den Warenkorb' erkannt – Warte 1 Sekunde, dann synchronisiere.", "info");
            setTimeout(syncBonusProduct, 1000);
        }
    });

    // Auf Cart-Seite sofort prüfen
    if (window.location.pathname.includes("/cart")) {
        log("Cart-Seite erkannt – sofort synchronisieren.", "info");
        syncBonusProduct();
    }

    window.syncBonusProduct = syncBonusProduct;
})();